"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSandboxName = void 0;
exports.getSandboxName = ({ alias, id, title, }) => title || alias || id;
